import {useContext} from 'react';
import Stack from '../../../shared/layouts/Stack';
import {useTranslation} from 'react-i18next';
import useIconLibrary from "../../../../hooks/useIconLibrary";
import QuickAction from "../components/QuickAction";
import ContactModalContext from "../../../../context/ContactModalContext";
import WhiteLabelContext from "../../../../context/WhiteLabelContext";

const QuickActionsWidget = () => {
  const { t } = useTranslation();
  const iconLibrary = useIconLibrary();
  const { setContactModalOpen, setDamageReportMode } = useContext(ContactModalContext);
  const { reportDamage, canSendConsumerMessages } = useContext(WhiteLabelContext);

  const actions = [
    ...(reportDamage && canSendConsumerMessages
      ? [
          {
            title: t('Schade melden'),
            message: t('Meld schade bij je adviseur'),
            Icon: iconLibrary.DamageIcon,
            action: () => {
              setDamageReportMode(true);
              setContactModalOpen(true);
            },
          },
        ]
      : []),
  ];

  if (actions.length === 0) {
    return null;
  }

  return (
    <Stack space="2xl" bg="white">
        <Stack space="m">
          {actions.map(({ ...action }, i) => (
            <QuickAction key={i} {...action} />
          ))}
        </Stack>
    </Stack>
  );
};

export default QuickActionsWidget;
